








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions } from '@/ts/store/Constants';
import AddButton from '@/components/Admin/Layout/AddButton.vue';
import SelectedItems from '@/components/Admin/Layout/SelectedItems.vue';
import VariantList from '@/components/Admin/Lists/VariantList.vue';
import EditVariantForm from '@/components/Admin/Forms/EditVariantForm.vue';
import UploadFloorPlan from '@/components/Admin/Forms/UploadFloorPlan.vue';
import VariantData from '@/ts/VariantData';
import ConfirmPopup from '@/components/Admin/Panels/ConfirmPopup.vue';

@Component({
    components: {
        AddButton,
        VariantList,
        EditVariantForm,
        SelectedItems,
        UploadFloorPlan,
        ConfirmPopup,
    },
    computed: {
        ...mapGetters({
            formVisible: 'Viewport/isAddFormVisible',
            confirmPopupVisibility: 'ConfirmPopup/getConfirmPopupVisibility',
        }),
    },
})

export default class Variants extends Vue {
    @Prop() public variantData!: VariantData;

    constructor() {
        super();
    }

    get hasSelectedProjects(): any {
        return this.$store.getters['Projects/selectedProjects'].length;
    }

    get hasSelectedBuildings(): any {
        return this.$store.getters['Buildings/selectedBuildings'].length;
    }

    get hasSelectedProperties(): any {
        return this.$store.getters['Properties/selectedProperties'].length;
    }

    get hasSelectedItem(): boolean {
        return this.hasSelectedProjects ||  this.hasSelectedBuildings || this.hasSelectedProperties;
    }

    get getVariantsData(): any {
        return this.$store.getters['Variants/allVariants'];
    }

    get activeVariant(): VariantData {
        return this.$store.getters['Variants/activeVariant'];
    }

    get addMenuVisible() {
        return this.$store.getters['Viewport/menuVisible'];
    }

    get editMenuVisible() {
        return this.$store.getters['Variants/editMenuVisible'];
    }

    get uploadFloorPlanMenuVisible() {
        return this.$store.getters['Variants/uploadFloorPlanMenuVisible'];
    }

    get editVariantFormVisible() {
        return this.$store.state.Variants.editFormVisible;
    }

    get uploadFloorPlanFormVisible() {
        return this.$store.state.Variants.uploadFloorPlanFormVisible;
    }

    get addMenuClass() {
        return {
            activeForm: this.addMenuVisible,
        };
    }

    get editMenuClass() {
        return {
            activeForm: this.editMenuVisible,
        };
    }

    get uploadFloorPlanMenuClass() {
        return {
            activeForm: this.uploadFloorPlanMenuVisible,
        };
    }

    public addVariant() {
        this.$store.dispatch(Actions.INITIATE_VARIANT);
        this.slideInForm('add-variant');
    }

    public slideInForm(formKey: string) {
        this.$store.dispatch(Actions.SHOW_FORM, formKey);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_VARIANTS);
    }
}
